<template>
  <div class="card-spotlight-event">
    <div class="card-spotlight-event__type">
      <ElementPreview type="event" :route="routeLink" />
    </div>
    <div class="card-spotlight-event__description">
      <BaseTitle class="card-spotlight-event__title" tag="h3">
        <router-link :to="routeLink">{{ content.title }}</router-link>
      </BaseTitle>
      <ElementIconText :text="content.schedule.start.date" icon="events" />
      <div class="card-spotlight-event__buttons">
        <BaseButton
          icon="arrow-right"
          icon-position="right"
          color="primary"
          :route="routeLink">
            {{ $t('message.common.buttons.viewDetails') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from '@base/BaseTitle'
import BaseButton from '@base/BaseButton'
import ElementIconText from '@elements/ElementIconText'
import ElementPreview from '@elements/ElementPreview'
export default {
  name: 'CardSpotlightNews',
  components: {
    BaseTitle,
    BaseButton,
    ElementIconText,
    ElementPreview
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    routeLink () {
      return `/calendar/event/${this.content.guid}`
    }
  }
}
</script>

<style lang="scss">
  // CFR CardSpotlight

  .card-spotlight-event{
    @include media("small-medium"){
      padding: layout("spacing")/2;
    }
    @include media("large"){
      padding: layout("spacing");
    }

    display: flex;

    // Title

    &__title{
      a{
        margin-right: 1rem;
      }
    }

    // Description

    &__description{
      @include media("small-medium"){
        display: flex;
        align-items: center;
      }
    }
  }
</style>
